/* eslint-disable */
import {isEmpty, isNullorUndefined, isNumber} from "./ObjectUtils";

// 必須項目チェック（True:全項目入力済、false:未入力項目あり）
export function validateRequired(...obj: any) {
    if (obj.length === 0) {
        return false;
   }

    for (let i: number = 0; i < obj.length; i++) {
		if (isEmpty(obj[i])) {
            return false;
       }
	}

    return true;
}

// 文字桁数取得（半角1桁、全角2桁）
export function countCharLength(obj: any) {

    if (isNullorUndefined(obj) || (isNumber(obj) && isNaN(obj))) {
        return 0;
   }

    let len = 0;
    let str = String(obj).replaceAll("\n", "");
    for (let i = 0; i < String(str).length; i++) {
        if (str[i].match(/[ｦ-ﾟ]+/)) {
            // 半角カタカナ
            len += 1;
       } else {
            if (escape(str[i]).match(/^%u/)) {
                // 全角文字
                len += 2;
           } else {
                // 半角英数
                len += 1;
           }
       }
   }

    return len;
}
